module.exports = __webpack_public_path__ + "icn_arrow_down_white.13adb57f5a4b90a86b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icn_arrow_down_white.png
// module id = 1483
// module chunks = 0